import { Notification, Message } from "element-ui";
import { getToken, removeToken } from "./auth";

var socket = null;//实例对象
var timeout = 20 * 1000; //20秒一次心跳
var timeoutObj = null; //心跳倒计时
// var wsUrlBase = 'ws://192.168.1.6:8085';
var wsUrlBase = 'ws://rdc.yikang.com.cn';

const initWebSocket = async () => {
  if ("WebSocket" in window) {
    const wsUrl = wsUrlBase + '/ws/web/' + getToken();
    socket = new WebSocket(wsUrl);
    socket.onerror = webSocketOnError;
    socket.onmessage = webSocketOnMessage;
    socket.onclose = closeWebsocket;
    socket.onopen = openWebsocket;
  } else {
    Message.error("您的浏览器不支持websocket，请更换Chrome或者Firefox");
  }
}

//建立连接
const openWebsocket = (e) => {
  start();
}

const start = () => {
  //开启心跳
  timeoutObj && clearTimeout(timeoutObj);
  timeoutObj = setInterval(function () {
    //这里发送一个心跳，后端收到后，返回一个心跳消息
    if (socket.readyState == 1) {
      //如果连接正常
      socket.send("heartbeat");
    } else if (socket.readyState == 3) {
      initWebSocket();
    } else {
      //否则重连
      initWebSocket();
    }
  }, timeout);
}

const sendWebsocket = (e) => {
  // socket.send(`我发消息了`);
}

const webSocketOnError = (e) => {
  initWebSocket();

}

//服务器返回的数据
const webSocketOnMessage = (e) => {
  if (e.data == '') {
    return false;
  }
  var result = JSON.parse(e.data);
  if (!result.status && result.code == 10008) {
    removeToken();
    Message.error(result.msg);
    window.location.hash = '/login';
    close();
  }
}

const closeWebsocket = (e) => {

}

//断开连接
const close = () => {
  //WebSocket对象也有发送和关闭的两个方法，只需要在自定义方法中分别调用send()和close()即可实现。
  if (socket) {
    socket.close();
  }
}
//具体问题具体分析,把需要用到的方法暴露出去
export default { initWebSocket, sendWebsocket, webSocketOnMessage, close };